import type { PageMeta } from '../types/seo'

// Canonical links always point at the live domain, so preview copies of the
// site are never treated as the original by search engines.
export const SITE_URL = 'https://breakapencil.com'

export function applyPageMeta(meta: PageMeta) {
  const url = SITE_URL + (meta.path === '/' ? '/' : meta.path)

  document.title = meta.title
  setMeta('name', 'description', meta.description)
  setMeta('property', 'og:title', meta.title)
  setMeta('property', 'og:description', meta.description)
  setMeta('property', 'og:url', url)
  setMeta('name', 'twitter:title', meta.title)
  setMeta('name', 'twitter:description', meta.description)
  setCanonical(url)

  const robots = document.head.querySelector<HTMLMetaElement>(
    'meta[name="robots"][data-page-meta]',
  )
  if (meta.noindex) {
    setMeta('name', 'robots', 'noindex')
  } else if (robots) {
    robots.remove()
  }
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    el.setAttribute('data-page-meta', '')
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}
